import { makeStyles } from '@material-ui/core/styles';

const useCommonStyles = makeStyles(theme => ({
    '@global': {
        a: {
            cursor: 'pointer',
        },
    },

    primary: {
        color: `${theme.palette.primary.main} !important`,
    },

    primary2: {
        color: `${theme.palette.secondary.contrastText} !important`,
    },

    primary2Border: {
        borderColor: `${theme.palette.secondary.contrastText} !important`,
    },

    primaryFont: {
        fontFamily: 'Lato !important',
    },

    secondary: {
        color: `${theme.palette.secondary.main} !important`,
    },

    secondary2: {
        color: '#717073',
    },

    secondary3: {
        color: '#EDEDED',
    },

    secondaryFont: {
        fontFamily: 'Alegreya Sans !important',
    },

    disabledSecondaryButton: {
        opacity: '50%',
        '&.MuiButton-contained': {
            backgroundColor: `${theme.palette.secondary.main} !important`,
            color: `${theme.palette.secondary.contrastText} !important`,
        },
        '&.MuiButton-outlined': {
            borderColor: `${theme.palette.secondary.main} !important`,
            color: `${theme.palette.secondary.main} !important`,
        },
    },

    fillSecondary: {
        fill: `${theme.palette.secondary.main} !important`,
    },

    secondaryBgColor: {
        backgroundColor: theme.palette.secondary.main,
    },

    smallFontSize: {
        fontSize: '0.75rem',
    },

    normalFontSize: {
        fontSize: '1rem',
    },

    bigFontSize: {
        fontSize: '1.25rem',
    },

    fontWeightLight: {
        fontWeight: 'lighter',
    },

    fontWeightBold: {
        fontWeight: 'bold',
    },

    dialog: {
        borderRadius: '10px',
    },

    onlyDesktopAndTablet: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inherit',
        },
    },

    onlyMobile: {
        display: 'inherit',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },

    placeholderOpacity: {
        opacity: '40%',

        '&.MuiInputBase-input.Mui-disabled': {
            opacity: '40%',
        },
    },

    avatarSmall: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },

    avatarBig: {
        width: theme.spacing(7),
        height: theme.spacing(7),
    },

    avatarExtraBig: {
        width: theme.spacing(11),
        height: theme.spacing(11),
    },

    cardContent: {
        padding: `${theme.spacing(4)}px !important`,
    },

    displayFlex: {
        display: 'flex',
    },

    fullWidth: {
        width: '100%',
    },

    fullHeight: {
        height: '100%',
    },

    autoMarginLeft: {
        marginLeft: 'auto',
    },

    autoMarginRight: {
        marginRight: 'auto',
    },

    formLabel: {
        marginBottom: theme.spacing(1),
    },

    table: {
        borderCollapse: 'separate',
        borderSpacing: '0 1rem',
    },

    tableRow: {
        '& > th, & > td': {
            borderBottom: 'none',
            backgroundColor: '#FFFFFF',

            '&:first-child': {
                borderRadius: '0.5rem 0 0 0.5rem',
            },

            '&:last-child': {
                borderRadius: '0 0.5rem 0.5rem 0',
                width: 'auto',
            },
        },

        '& > th': {
            color: '#A3A3A3',
        },
    },

    buttonGroup: {
        '& > *': {
            margin: `0 ${theme.spacing(1)}px`,
            [theme.breakpoints.down('sm')]: {
                margin: theme.spacing(1),
            },
        },
    },

    title: {
        [theme.breakpoints.up('sm')]: {
            marginTop: theme.spacing(4),
            marginBottom: theme.spacing(5),
        },
    },

    disabledLink: {
        opacity: '0.5',
        cursor: 'default',
    },

    cursorPointer: {
        cursor: 'pointer',
    },

    vehicleLogo: {
        marginLeft: 'auto',
        maxHeight: '3.5rem',
        maxWidth: '7rem',
        height: 'fit-content',
    },

    rightTextAlign: {
        textAlign: 'right',
    },

    leftTextAlign: {
        textAlign: 'left',
    },

    ellipsisTextOverflow: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },

    breakAllWordBreak: {
        wordBreak: 'break-all',
    },

    subMenusRoot: {
        borderRadius: theme.spacing(1),
        border: '1px solid #C4C4C4',
    },

    subMenusindicator: {
        display: 'none',
    },

    subMenuTabRoot: {
        width: '50%',
        maxWidth: '50% !important',
    },

    subMenuTabSelected: {
        backgroundColor: theme.palette.primary.main,
    },

    removeBoxShadow: {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none',
        },
    },

    transactionStatus: {
        color: theme.palette.secondary.contrastText,
        whiteSpace: 'nowrap',
        paddingRight: theme.spacing(1),
        paddingLeft: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
        borderRadius: theme.spacing(0.5),
        width: 'fit-content',
        height: 'fit-content',
        fontSize: '14px',
    },

    cardBoxShadow: {
        boxShadow: '0px 0px 20px #00000029',
    },

    centerAlignItems: {
        alignItems: 'center',
    },
    redText: {
        color: 'red !important',
    },
    flexWrap: {
        flexWrap: 'wrap',
    },

    borderedTop: {
        borderTop: '1px solid black',
    },
    borderedRight: {
        borderRight: '1px solid black',
    },
    borderedBottom: {
        borderBottom: '1px solid black',
    },
    borderedLeft: {
        borderLeft: '1px solid black',
    },
}));

export default useCommonStyles;
